module.exports = __webpack_public_path__ + "static/media/wrong.2552fb3b.png";